// extracted by mini-css-extract-plugin
export default {"homeBody":"Home_homeBody__so-7V","homeExpand":"Home_homeExpand__XtHYy"};